import React, { CSSProperties, useEffect, useState } from 'react';
import { LoadableVideoPlayer } from './loadable_video_player';
import { useDimensions } from '../../hooks/use_dimensions';
import styles from './dockable_video_player.less';
import { CloseOutlined } from '@ant-design/icons';
import { HTMLPlyrVideoElement } from './video_player';
import { useInView } from 'react-intersection-observer';

interface DockableVideoPlayerProps {
  muxPlaybackId?: string;
  dockable?: boolean;
  autoPlay?: boolean;
  thumbnailUrl?: string;
  thumbnailTimeStamp?: number;
}
export const DockableVideoPlayer = (props: DockableVideoPlayerProps) => {
  const { muxPlaybackId, dockable = true, autoPlay, thumbnailTimeStamp, thumbnailUrl } = props;
  const [videoDocked, setVideoDocked] = useState(false);
  const [userUndocked, setUserUndocked] = useState(false);
  const [videoRef, setVideoRef] = useState(null as HTMLPlyrVideoElement);
  const { ref, inView } = useInView({
    initialInView: true,
  });
  const plyr = videoRef?.plyr;
  const [measureRef, bounds] = useDimensions();

  useEffect(() => {
    if (!userUndocked) {
      setVideoDocked(!inView);
    }
  }, [inView]);

  useEffect(() => {
    if (userUndocked) {
      setVideoDocked(false);
    }
  }, [userUndocked]);

  useEffect(() => {
    if (!plyr) {
      return;
    }

    plyr.on('play', (e) => {
      setUserUndocked(false);
    });
  }, [plyr]);

  const muxThumbnail = `https://image.mux.com/${muxPlaybackId}/thumbnail.jpg`;
  const muxThumbnailWithTimeStamp = `${muxThumbnail}?time=${thumbnailTimeStamp}`;

  const videoStyles: CSSProperties =
    videoDocked && dockable
      ? {
          bottom: 10,
          right: 10,
          top: 'auto',
          left: 'auto',
          width: bounds ? bounds.width : 'auto',
          transform: 'scale(0.7)',
          position: 'fixed',
          zIndex: 4,
        }
      : {};
  return (
    <div className={styles.video}>
      <div ref={ref} />
      <div className={styles.videoPlaceholder} ref={measureRef} />
      <div className={styles.mux} style={videoStyles}>
        <LoadableVideoPlayer
          muxPlaybackId={muxPlaybackId}
          ref={(video) => {
            setVideoRef(video);
          }}
          source={{
            type: 'video',
            poster: thumbnailUrl || thumbnailTimeStamp ? muxThumbnailWithTimeStamp : muxThumbnail,
            sources: [
              {
                src: 'currently the muxid creates the source internally',
              },
            ],
          }}
          options={{
            controls: [
              'play-large',
              'play',
              'fast-forward',
              'progress',
              'current-time',
              'mute',
              'volume',
              'fullscreen',
            ],
            // this doesn't seem to work
            autoplay: autoPlay,
          }}
        />
        {videoDocked && (
          <button onClick={() => setUserUndocked(true)} className={styles.unDockButton}>
            <CloseOutlined />
          </button>
        )}
      </div>
    </div>
  );
};
